
export enum EmployeePayBillTypeEnum {
    Allowances = "Allowances",
    Deductions = "Deductions",
}

export enum EmployeePayBillAllowanceEnum {
    basic = 'basic',
    hraAmount = 'hraAmount',
    eduAmount = 'eduAmount',
    medicalAmount = 'medicalAmount',
    splAmount = 'splAmount',
    conveyanceAmount = 'conveyanceAmount',
    petrolAmount = 'petrolAmount',
    shoeAmount = 'shoeAmount',
    washingAmount = 'washingAmount',
    uniformAmount = 'uniformAmount',
    helperAmount = 'helperAmount',


}


export enum workerPayBillAllowanceEnum{
    basic ='basic',
    uniformAmount ='uniformAmount',
    taAmount ='taAmount',
    medicalAmount ='medicalAmount',
    splAmount = 'splAmount',
    productionAmount ='productionAmount',
    bonusAmount ='bonusAmount',
    washingAmount = 'washingAmount',
    shoeAmount = 'shoeAmount',

   
}

export enum EmployeePayBillDeductionEnum {
    messAmount = "messAmount",
    othersAmount = "othersAmount",


}
